/**
 * ritorna una promise che si esaurisce nel timeout stabilito
 * e riotrna il valore specificato
 * @param millis timeout
 * @param outval valore di ritorno
 * @returns 
 */
 function timeout<A>(millis: number, outval: A|null): Promise<A> {

    return new Promise<A>((resolve) => {
        setTimeout(() => {
            resolve(outval);
        }, millis);
    });     
}


/**
 * Promise risolvibile esternamente
 */
export class OuterResolvablePromise<A> {

    public readonly promise: Promise<A>;
    private resolver: (a: A) => void;
    private rejector: (a: any) => void;
    constructor() {
        this.promise = new Promise<A>((res, rej) => {
            this.resolver = res;
            this.rejector = rej;
        });
    }

    
    resolve(a: A): void {
        this.resolver(a);
    }
    reject(e: any): void {
        this.rejector(e);
    }

    chainResolve(prom: Promise<A>, onErr: A = null): void {
        prom.then(res => this.resolve(res)).catch(err => this.resolve(onErr));
    }
}

function getResolvable<A>(): OuterResolvablePromise<A> {
    return new OuterResolvablePromise<A>();
}

export interface LockPromise {
    waitLock: Promise<void>,
    unlock(): void
}






function promiseOnWindowClose(w: Window): Promise<boolean> {
    return new Promise((resolve, _rej) => {
        const checkfun = () => {
            if(w.closed !== false) resolve(true);
            else window.setTimeout(checkfun, 100);
        };
        checkfun();
    });
    
}


export const PromiseOnSteroids = {

    timeout: timeout,
    getResolvable: getResolvable,
    getLock(): LockPromise {
        const res = getResolvable<void>();
        return {
            waitLock: res.promise,
            unlock(): void {
                res.resolve();
            }
        };
    },
    windowClosePromise: promiseOnWindowClose
};